import { batch } from "react-redux";

import { setIsPauseHandled } from "@/actions/autoProfileStateAction";
import {
  setCurrentBuffer,
  setProfileRunning,
  updateDialfiltrationStatus,
  updateRefilledBufferVolume,
  updateShowRefillBuffer,
} from "@/actions/setupActions";
import {
  postCancelRefillConcentrator,
  postRefillConcentrator,
  postStopConcentrator,
} from "@/api/concentratorApi";
import { StopEnum } from "@/constants/autoProfileEnum";
import * as APPDATA from "@/constants/pcConstAppData";

import {
  hidePauseToRefillModal,
  showPauseToRefillModal,
} from "./autoProfileBusiness";

export function continueRefillBufferVol(volume) {
  return async (dispatch) => {
    try {
      await postRefillConcentrator(volume);

      batch(() => {
        dispatch(setIsPauseHandled(false));
        dispatch(updateShowRefillBuffer(false));
        dispatch(updateRefilledBufferVolume(APPDATA.EMPTY_FIELD));
        dispatch(hidePauseToRefillModal());
      });
    } catch (error) {
      console.log("continueRefillBufferVol error", error);
    }
  };
}

export function stopRefillBufferVol() {
  return async (dispatch) => {
    try {
      await postStopConcentrator(StopEnum.MANUAL_CONTROL);

      batch(() => {
        dispatch(setIsPauseHandled(false));
        dispatch(updateRefilledBufferVolume(APPDATA.EMPTY_FIELD));
        dispatch(updateShowRefillBuffer(false));
      });
    } catch (error) {
      console.log("stopRefillBufferVol error", error);
    }
  };
}

export function cancelRefillBufferVol() {
  return async (dispatch, getState) => {
    try {
      const { autoProfileState } = { ...getState() };
      const { isPauseHandled } = autoProfileState;

      if (isPauseHandled) {
        batch(() => {
          dispatch(updateShowRefillBuffer(false));
          dispatch(updateRefilledBufferVolume(APPDATA.EMPTY_FIELD));
          dispatch(showPauseToRefillModal());
        });
      } else {
        await postCancelRefillConcentrator();

        batch(() => {
          dispatch(updateShowRefillBuffer(false));
          dispatch(updateRefilledBufferVolume(APPDATA.EMPTY_FIELD));
        });
      }
    } catch (error) {
      console.log("cancelRefillBufferVol error", error);
    }
  };
}

export function refillBufferVolumeOnInit(
  dialfiltrationStatus,
  profileRunning,
  currentBuffer
) {
  return async (dispatch, getState) => {
    try {
      const { setupStore } = { ...getState() };
      const { dialfiltrationStatus: currDialfiltrationStatus } = setupStore;
      const { ShouldRefilledBuffer: currShouldRefilledBuffer } =
        currDialfiltrationStatus;

      const { ShouldRefilledBuffer } = dialfiltrationStatus;

      batch(() => {
        dispatch(setProfileRunning(profileRunning));
        dispatch(setCurrentBuffer(currentBuffer));
        if (
          currShouldRefilledBuffer === APPDATA.ENUM.MANUAL_CONTROL_STATE.DISABLE
        ) {
          if (
            ShouldRefilledBuffer === APPDATA.ENUM.MANUAL_CONTROL_STATE.ENABLE
          ) {
            dispatch(updateDialfiltrationStatus(dialfiltrationStatus));
            dispatch(updateShowRefillBuffer(true));
          }
        } else if (
          ShouldRefilledBuffer === APPDATA.ENUM.MANUAL_CONTROL_STATE.DISABLE
        ) {
          dispatch(updateDialfiltrationStatus(dialfiltrationStatus));
        }
      });
    } catch (error) {
      console.log("refillBufferVolumeOnInit error", error);
    }
  };
}

export function handleRefillBufferVolumeOnEvent(newStatus) {
  return async (dispatch) => {
    try {
      const { ShouldRefilledBuffer } = newStatus;
      batch(() => {
        switch (ShouldRefilledBuffer) {
          case APPDATA.ENUM.MANUAL_CONTROL_STATE.ENABLE:
            dispatch(updateDialfiltrationStatus(newStatus));
            dispatch(updateShowRefillBuffer(true));
            break;
          case APPDATA.ENUM.MANUAL_CONTROL_STATE.DISABLE:
            dispatch(updateDialfiltrationStatus(newStatus));
            break;
          default:
            break;
        }
      });
    } catch (error) {
      console.log("handleRefillBufferVolumeOnEvent error", error);
    }
  };
}
